
import { defineComponent } from 'vue';
import { AppCard, AppTable, AppButton, AppFormRow, AppInput, AppSelect, AppImageHolder } from '@/components';
import { useStarterPackDetail } from '@/modules/starter/pack/model/detail';
import { StarterPackRewardOptions, StarterPackRewardType } from '@/modules/starter/pack/reward/types';
import { ROUTE_NAME_STARTER } from '@/modules/starter/pack/router';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { renderBoolean } from '@/common/utils/helpers';

export default defineComponent({
    name: ROUTE_NAME_STARTER.PACK.DETAIL,
    components: { AppCard, AppTable, AppButton, AppFormRow, AppInput, AppSelect, AppImageHolder },
    setup() {
        const { model, rewardDetailtList, actions, rewardCreationModal } = useStarterPackDetail();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Option, label: 'Type', key: 'type', options: StarterPackRewardOptions },
                { type: TableColumnType.RouterLink, label: 'Item', key: 'itemName', to: row => row.itemLink },
                { type: TableColumnType.Text, label: 'Quantity', key: 'quantity' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-trash-alt',
                        theme: 'danger',
                        tooltip: 'Delete',
                        disabled: !model.canEdit,
                        onClick: () => actions.removeReward(model.id, row.type, row.data)
                    })
                }
            ]
        };

        return {
            model,
            table,
            actions,
            rewardDetailtList,
            rewardCreationModal,
            StarterPackRewardOptions,
            StarterPackRewardType,
            renderBoolean
        };
    }
});
